// =============================================================
//  mayaChatStore — Persistence de la conversation Maya par
//  utilisateur, dans Firestore (maya_chats/{uid}/messages).
//
//  La Cloud Function écrit aussi côté serveur après chaque réponse,
//  mais l'app peut écrire de son côté pour :
//    - sauvegarder les messages "user" envoyés (lecture immédiate)
//    - sauvegarder les pièces jointes (la Function ne les voit pas)
//  En cas de double écriture, c'est OK (la collection accepte
//  plusieurs entrées).
// =============================================================

import {
  collection,
  doc,
  getDocs,
  query,
  orderBy,
  limit,
  addDoc,
  serverTimestamp,
} from 'firebase/firestore';
import { db } from '../../private/firebaseConfig';

const HISTORY_LIMIT = 100; // 100 derniers messages chargés à l'ouverture du chat

const messagesRef = (uid) =>
  collection(doc(db, 'maya_chats', uid), 'messages');

/**
 * Charge l'historique (jusqu'à 100 derniers messages) pour un utilisateur.
 * Renvoie [] si rien ou erreur.
 */
export const loadChatHistory = async (uid) => {
  if (!uid) return [];
  try {
    const q = query(messagesRef(uid), orderBy('createdAt', 'desc'), limit(HISTORY_LIMIT));
    const snap = await getDocs(q);
    const items = snap.docs.map((d) => {
      const data = d.data();
      return {
        id: d.id,
        sender: data.role === 'user' ? 'user' : 'bot',
        text: data.content || '',
        attachment: data.attachment || null,
        createdAt: data.createdAt?.toMillis?.() ?? 0,
      };
    });
    // Affichage chronologique
    items.sort((a, b) => a.createdAt - b.createdAt);
    return items;
  } catch (e) {
    if (__DEV__) console.warn('[Maya] loadChatHistory failed', e?.message || e);
    return [];
  }
};

/**
 * Sauvegarde un message côté app (en plus de ce que fait la Cloud Function).
 * Utilisé pour les pièces jointes (que la Function ne reçoit pas).
 */
export const saveChatMessage = async (uid, message) => {
  if (!uid) return;
  try {
    await addDoc(messagesRef(uid), {
      role: message.sender === 'user' ? 'user' : 'assistant',
      content: message.text || '',
      attachment: message.attachment || null,
      createdAt: serverTimestamp(),
    });
  } catch (e) {
    if (__DEV__) console.warn('[Maya] saveChatMessage failed', e?.message || e);
  }
};
